<template>
	<div>
		<b-row>
			<b-col cols="6">
				<FITDatePicker field='commissionEffectiveFrom' :label="$t('osm.product.commissionEffectiveFrom')" :width="8" v-model="value.commissionEffectiveFrom"></FITDatePicker>
				<FITTextInput field='year1AnnualBonus' :label="$t('osm.product.year1AnnualBonus')" :width="8" v-model="value.year1AnnualBonus"></FITTextInput>
				<FITTextInput field='year1Override' :label="$t('osm.product.year1Override')" :width="8" v-model="value.year1Override"></FITTextInput>
				<template v-for="item in 7">
					<FITTextInput :field="`year${item}Comm`" :label="$t('osm.product.yearComm', {year: item})" :width="8" v-model="value[`year${item}Comm`]"></FITTextInput>
				</template>
			</b-col>
			<b-col cols="6">
				<FITDatePicker field='commissionEffectiveTo' :label="$t('osm.product.commissionEffectiveTo')" :width="8" v-model="value.commissionEffectiveTo"></FITDatePicker>
				<FITTextInput field='year2AnnualBonus' :label="$t('osm.product.year2AnnualBonus')" :width="8" v-model="value.year2AnnualBonus"></FITTextInput>
				<FITTextInput field='year2Override' :label="$t('osm.product.year2Override')" :width="8" v-model="value.year2Override"></FITTextInput>
			</b-col>
		</b-row>
	</div>
</template>
<script type="text/javascript">
import {
	FITTextInput,
	FITDatePicker,
} from '@/components'
export default {
	name: 'NewCommission',
	props: ['value'],
	components: {
		FITTextInput,
		FITDatePicker,
	}
}

</script>



// WEBPACK FOOTER //
// src/Osm/Product/components/NewCommission.vue